import { DrycutApolloProvider } from '@drycut/apollo';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router';

import router from './router';
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <DrycutApolloProvider>
      <RouterProvider router={router} />
    </DrycutApolloProvider>
  </StrictMode>,
);
